import { useEffect, useRef, useState } from "react";
import gsap from "gsap";

interface BottomHintProps {
  interacted: boolean;
}

export function BottomHint({ interacted }: BottomHintProps) {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const t = window.setTimeout(() => setVisible(true), 3000);
    return () => window.clearTimeout(t);
  }, []);

  useEffect(() => {
    if (!ref.current) return;
    if (visible && !interacted) {
      gsap.fromTo(
        ref.current,
        { y: 8, opacity: 0 },
        { y: 0, opacity: 1, duration: 0.8, ease: "power2.out" },
      );
    } else if (interacted) {
      gsap.to(ref.current, { y: 8, opacity: 0, duration: 0.4, ease: "power2.in" });
    }
  }, [visible, interacted]);

  if (!visible) return null;

  return (
    <div
      ref={ref}
      className="pointer-events-none fixed bottom-6 md:bottom-10 left-1/2 -translate-x-1/2 z-20 opacity-0"
    >
      <p
        className="font-mono-caps text-foreground-400"
        style={{ fontSize: "10px", letterSpacing: "0.28em" }}
      >
        Drag the clay to shape · Scroll to lean in
      </p>
    </div>
  );
}